var qna_host='';
var hrs = -(new Date().getTimezoneOffset() / 60)
if (process.env.REACT_APP_API_HOST=='https://app.astrnt.co') {
  if (hrs == 0 || hrs == 1) {
     qna_host = 'https://qna-db.astrnt.co'
  }else{
    qna_host = process.env.REACT_APP_QNA_HOST
  }
}else{
  if (hrs == 0 || hrs == 1) {
      qna_host = 'https://qnb-db.astrnt.co'
  }else{
    qna_host = process.env.REACT_APP_QNA_HOST
  }
}
const initializers = {
  version: "2.0.0",
  api_host: process.env.REACT_APP_API_HOST || "https://beta.astrnt.co",
  api_host_eu: process.env.REACT_APP_API_HOST_EU || "https://app-eu.astrnt.co",
  recruiter_host: process.env.REACT_APP_RECRUITER_HOST || "https://app.astrnt.co",
  // link_check_host: "https://pychecklink.astrnt.co/"||"http://127.0.0.1:5000/",
  link_check_host: process.env.REACT_APP_PYTHON_HOST || "http://127.0.0.1:5000/" ,
  api_v2_host: process.env.REACT_APP_NODE_HOST||"http://localhost:3001/",
  // api_v2_host: "https://api-v2-beta.astrnt.co/",
  qna_host: qna_host,
  qna_host_eu: process.env.REACT_APP_QNA_HOST_EU || "https://qna-eu.astrnt.co",
  blog_host: process.env.REACT_APP_BLOG_HOST || "https://life-az.astrnt.co",
  dev_host: process.env.REACT_APP_DEV_HOST || "https://dev-az.astrnt.co",
};
// commits to trigger master
export default initializers;